import { Dropdown, Option } from 'easyship-components';
import { Check } from 'easyship-components/icons';

import { useI18n } from '@/providers/I18nProvider/context';
import { EasyshipLocale, SUPPORTED_LOCALES } from '@/providers/I18nProvider/types';
import GlobeSVG from '@/svg/Globe.svg';

export const LOCALE_LABELS: Record<EasyshipLocale, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  nl: 'Nederlands',
};

export const LocaleSelector = () => {
  const { locale, setLocale } = useI18n();

  const options: Option<EasyshipLocale>[] = SUPPORTED_LOCALES.map((option) => ({
    value: option,
    label: LOCALE_LABELS[option],
    leadingElement:
      option === locale ? (
        <Check className="size-[11px] shrink-0 text-ink-900" />
      ) : (
        <span className="inline-block size-[11px] shrink-0" aria-hidden="true" />
      ),
  }));

  const selectedOption: Option<EasyshipLocale> = {
    value: locale,
    label: LOCALE_LABELS[locale],
  };

  const handleChange = (option: Option<EasyshipLocale> | Option<EasyshipLocale>[] | null) => {
    if (!option || Array.isArray(option)) {
      return;
    }

    setLocale(option.value);
  };

  return (
    <Dropdown
      className="w-[160px]"
      icon={<img src={GlobeSVG} alt="" aria-hidden="true" className="size-4" />}
      options={options}
      value={selectedOption}
      onChange={handleChange}
    />
  );
};
